const Scripts = () => {
  return (
    <>
      <script
        type="text/javascript"
        src="https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=l1qe7rh534&callback=initMap"
      />
      <script type="text/javascript" src="https://developers.kakao.com/sdk/js/kakao.js" async />
    </>
  );
};

export default Scripts;
